import React from 'react';
import { Button, Col, Row, Typography } from 'antd';
import { useParams } from 'react-router';
import buskwarehousedetail from '@modules/Busk/BuskWarehouseDetail/services/buskwarehousedetail';

interface IProps {
  totalReturnProduct: number;
  selectedReturnProduct: React.Key[];
}

const ReturnProductListHead = ({
  totalReturnProduct,
  selectedReturnProduct
}: IProps) => {
  const { id } = useParams<{ id: string }>();

  const handleExport = async () => {
    if (selectedReturnProduct.length > 0) {
      const response =
        await buskwarehousedetail.exportReturnProduct(
          id,
          selectedReturnProduct
        );
      const outputFilename = `Return_product_240406T9g6QGJSxyR.xlsx`;

      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const response =
        await buskwarehousedetail.exportReturnProduct(
          id
        );
      const outputFilename = `Return_product_240406T9g6QGJSxyR.xlsx`;

      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  }

  return (
    <div className="busk-sellerSubHead">
      <Row align="middle">
        <Col flex="auto">
          <Row gutter={15}>
            <Col>
              <Typography.Text>총 반품 {totalReturnProduct}</Typography.Text>
            </Col>
            <Col>|</Col>
            <Col>
              <Typography.Text>
                선택 반품 {selectedReturnProduct.length}
              </Typography.Text>
            </Col>
          </Row>
        </Col>
        <Col>
          <Button
            style={{
              color: 'gray'
            }}
            onClick={() => handleExport()}
          >
            엑셀 다운로드
          </Button>
        </Col>
      </Row>
    </div>
  );
}

export default ReturnProductListHead;